"use client";

import { createStore, Provider } from "jotai";
import { ReactNode } from "react";

export const jotaiStore = createStore();

export function JotaiProvider({ children }: { children: ReactNode }) {
  return <Provider store={jotaiStore}>{children}</Provider>;
}
